import { ChatMessage } from "src/base-components/Chat/ChatMessage";
import { Skeleton } from "src/design-system/Skeleton";

const AssistantMessageSkeleton: React.FC<{ compact?: boolean }> = ({
  compact = false,
}) => (
  <ChatMessage
    dataLoc="unified-copilot-session-loading-assistant"
    role="assistant"
  >
    <div className="flex flex-col gap-y-2">
      <Skeleton height="h-4" width="w-full" />
      <Skeleton height="h-4" width={compact ? "w-1/2" : "w-full"} />
      {!compact && <Skeleton height="h-4" width="w-3/4" />}
    </div>
  </ChatMessage>
);

export const UnifiedCopilotSessionLoadingSkeleton: React.FC = () => (
  <>
    <ChatMessage dataLoc="unified-copilot-session-loading-user" role="user">
      <Skeleton height="h-10" rounded="rounded-lg" width="w-2/3" />
    </ChatMessage>
    <AssistantMessageSkeleton />
    <ChatMessage dataLoc="unified-copilot-session-loading-user" role="user">
      <Skeleton height="h-8" rounded="rounded-lg" width="w-1/2" />
    </ChatMessage>
    <AssistantMessageSkeleton compact />
  </>
);
